import { db } from "../utils/firestore";
import { coalescerCadastro } from "../utils/coalescerCadastro";
import { normalizarSearchableName } from "../utils/searchableName";
import {
  doc,
  getDoc,
  collection,
  addDoc,
  getDocs,
  updateDoc,
  // deleteDoc,
  query,
  orderBy,
  where,
  startAfter,
  endBefore,
  limit,
  setDoc,
  runTransaction,
  Timestamp,
  getCountFromServer,
} from "firebase/firestore";
import { uniq } from "../utils/arrayUtils";
import { generateTrigam } from "../utils/trigamUtils";
import axios from "axios";
import AuthenticatedApiService from "./AuthenticatedApiService";
import { criarCadastroUsuario } from "./GrupoPadrao.service";
import { PraticanteModelo } from "../components/entidades/praticantes/models/praticate.modelo";

//const dbCollection = db.collection("/usersgroups");

class usersService {
  //import { db } from '../utils/firestore'; // update with your path to firestore config
  //import { doc, getDoc } from "firebase/firestore";

  /**
   * Método helper para fazer requisições híbridas (com/sem autenticação)
   * Tenta primeiro com autenticação, se falhar (401), tenta sem autenticação
   * @param {string} endpoint - Endpoint da API
   * @param {Object} data - Dados da requisição
   * @returns {Promise} Resposta da API
   */
  async makeHybridApiRequest(endpoint, data) {
    try {
      // Primeira tentativa: com autenticação
      return await AuthenticatedApiService.post(endpoint, data);
      
    } catch (error) {
      // Se erro 401 (não autorizado), tenta sem autenticação para compatibilidade
      if (error.response && error.response.status === 401) {
        console.log(`[USERS-API] Falha na autenticação (401), tentando POST ${endpoint} sem autenticação...`);
        
        try {
          const url = import.meta.env.VITE_BACKEND_API_URL + endpoint;
          return await axios.post(url, data);
        } catch (fallbackError) {
          console.error(`[USERS-API] Falha também sem autenticação:`, fallbackError);
          throw fallbackError;
        }
      } else {
        // Se não for erro 401, propaga o erro original
        // 403 = API indisponível neste ambiente — silencioso para não poluir o console
        if (error?.response?.status !== 403 && error?.status !== 403) {
          console.error(`[USERS-API] Erro na requisição autenticada:`, error);
        }
        throw error;
      }
    }
  }

  getRulesOwned = async (id) => {
    var allRulesOwned = [];
    try {
      if (id) {
        await getDoc(doc(db, "users", id)).then(async (userSnapshot) => {
          if (userSnapshot.exists()) {
            let usersgroupsowned = userSnapshot.data().usersgroupsowned;
            // ⚠️ Em `usersgroups` o campo é PLANO: `metadataactive`. Os 91
            // documentos da coleção têm `metadataactive` e ZERO têm
            // `metadados.active` — o padrão de map aninhado vale para `users`,
            // `praticantes`, `portais` e `contas`, mas não aqui. Com o filtro
            // errado esta consulta casava com 0 grupos e a função devolvia
            // NENHUMA permissão, em silêncio. (Sem chamadores hoje; o caminho
            // vivo é `getRulesOwnedUnderPortalID`, que sempre usou o certo.)
            await getDocs(query(collection(db, "usersgroups"), where("metadataactive", "==", true))).then((usersGroups) => {
              if (usersGroups) {
                usersGroups.docs.map((doc) => {
                  if (usersgroupsowned.includes(doc.id)) {
                    allRulesOwned = [...allRulesOwned, ...doc.data().rulesowned];
                  }
                });
              }
            });
          }
        });
        return uniq(allRulesOwned);
      } else {
        throw new Error("Registro não encontrado!");
      }
    } catch (error) {
      throw error;
    }
  };
  //usage: getUsersGroupsOwned(id);

  getRulesOwnedUnderPortalID = async (id, portalID) => {
    var allRulesOwned = [];
    try {
      if (id) {
        await getDoc(doc(db, "users", id)).then(async (userSnapshot) => {
          if (userSnapshot.exists()) {
            let usersgroupsowned = [];
            userSnapshot.data().usersgroupsowned.map((thisGroupsOwned) => {
              if (thisGroupsOwned.portalID === portalID) {
                thisGroupsOwned.groupsOwned.map((groupOwned) => {
                  usersgroupsowned.push(groupOwned);
                });
              }
            });
            await getDocs(query(collection(db, "usersgroups"), where("metadataactive", "==", true))).then((usersGroups) => {
              if (usersGroups) {
                usersGroups.docs.map((doc) => {
                  if (usersgroupsowned.includes(doc.id)) {
                    allRulesOwned = [...allRulesOwned, ...doc.data().rulesowned];
                  }
                });
              }
            });
          } else {
            //console.log("User not found!");
          }
        });
        return uniq(allRulesOwned);
      } else {
        throw new Error("Registro não encontrado!");
      }
    } catch (error) {
      throw error;
    }
  };
  //usage: getUsersGroupsOwned(id);

  getOne = async (id) => {
    try {
      if (id) {
        const noteSnapshot = await getDoc(doc(db, "users", id));
        if (noteSnapshot.exists()) {
          return noteSnapshot.data();
        } else {
          throw new Error("Registro não encontrado!");
        }
      } else {
        return null;
      }
    } catch (error) {
      throw error;
    }
  };
  //usage: getNote(id);

  getOneByPinCode = async (pinCode) => {
    try {
      if (pinCode) {
        const noteSnapshot = await getDocs(query(collection(db, "users"), where("dadosSeguranca.pincode", "==", pinCode)));
        if (noteSnapshot.docs.length > 0) return { id: noteSnapshot.docs[0].id, ...noteSnapshot.docs[0].data() };
        else throw new Error("Registro não encontrado!");
      } else {
        return null;
      }
    } catch (error) {
      throw error;
    }
  };
  //usage: getNote(id);

  getAll = async (limite) => {
    if (limite === undefined) {
      const querySnapshot = await getDocs(
        query(collection(db, "users"), where("metadados.active", "==", true), orderBy("dadosPessoais.name", "asc"))
      );
      return querySnapshot.docs;
    } else {
      const querySnapshot = await getDocs(
        query(collection(db, "users"), where("metadados.active", "==", true), limit(limite), orderBy("dadosPessoais.name", "asc"))
      );
      return querySnapshot.docs;
    }
  };

  getCollectionSize = async () => {
    // const querySnapshot = await getDocs(
    //   query(
    //     collection(db, "users"),
    //     where("metadados.active", "==", true)
    //     // orderBy("dadosPessoais.name", "asc")
    //   )
    // );
    // return querySnapshot.docs.length;
    const q = query(collection(db, "users"), where("metadados.active", "==", true));
    const snapshot = await getCountFromServer(q);
    //console.log("count: ", snapshot.data().count);
    return snapshot.data().count;
  };

  getFilteredCollection = async (filterTarget, operation, filterValue) => {
    let querySnapshot = {};
    //console.log(filterTarget, operation, filterValue);
    if (filterTarget === "dadosPessoais.name")
      querySnapshot = await getDocs(
        query(collection(db, "users"), where(filterTarget, operation, filterValue), orderBy("dadosPessoais.name", "asc"))
      );
    else
      querySnapshot = await getDocs(
        query(collection(db, "users"), where(filterTarget, operation, filterValue), orderBy(filterTarget, "dadosPessoais.name", "asc"))
      );
    return querySnapshot.docs;
  };

  // getFilteredCollection = async (filterTarget, operation, filterValue) => {
  //   const querySnapshot = await getDocs(
  //     query(collection(db, "users"), where(filterTarget, operation, filterValue), orderBy("dadosPessoais.name", "asc"))
  //   );
  //   return querySnapshot.docs;
  // };

  getCollectionSearchActiveByPrefixLimited = async (queryTarget, queryText, queryLimit) => {
    //console.log(queryTarget, queryText, queryLimit);
    const querySnapshot = await getDocs(
      query(
        collection(db, "users"),
        where("metadados.active", "==", true),
        // where(queryTarget, ">=", queryText),
        // where(queryTarget, "<=", queryText + "\uf8ff"),
        where(queryTarget, "array-contains-any", [...generateTrigam(queryText)]),
        orderBy("dadosPessoais.name", "asc"),
        limit(queryLimit)
      )
    );
    return querySnapshot.docs;
  };

  getCollectionSearchByPrefix = async (queryTarget, queryText) => {
    const querySnapshot = await getDocs(
      query(
        collection(db, "users"),
        // where(queryTarget, ">=", queryText),
        // where(queryTarget, "<=", queryText + "\uf8ff"),
        where(queryTarget, "array-contains-any", [...generateTrigam(queryText)]),
        orderBy("dadosPessoais.name", "asc")
      )
    );
    return querySnapshot.docs;
  };

  getPrevPage = async (firstVisible, pageSize) => {
    let querySnapshot = await getDocs(
      query(
        collection(db, "users"),
        where("metadados.active", "==", true),
        orderBy("dadosPessoais.name", "asc"),
        limit(pageSize),
        endBefore(firstVisible)
      )
    );
    return querySnapshot.docs;
  };

  getNextPage = async (lastVisible, pageSize) => {
    let querySnapshot = null;
    if (lastVisible !== null) {
      querySnapshot = await getDocs(
        query(
          collection(db, "users"),
          where("metadados.active", "==", true),
          orderBy("dadosPessoais.name", "asc"),
          limit(pageSize),
          startAfter(lastVisible)
        )
      );
    } else {
      querySnapshot = await getDocs(
        query(collection(db, "users"), where("metadados.active", "==", true), orderBy("dadosPessoais.name", "asc"), limit(pageSize))
      );
    }
    // //console.log("querySnapshot=", querySnapshot);
    return querySnapshot.docs;
  };

  create = async (value) => {
    try {
      // value = { ...value, dadosPessoais: { ...value.dadosPessoais, trigam: generateTrigam(value.dadosPessoais.name) } };
      // if (isNaN(value.metadados.creation)) {
      //   value.metadados.creation = Timestamp.fromDate(new Date());
      // }
      // if (value.metadados.owner === null) value.metadados.owner = value.dadosPessoais.name;
      // return await addDoc(collection(db, "users"), value);
      return await this.createWithID("", value);
    } catch (error) {
      throw error;
    }
  };

  // Coalescido: este é o caminho VIVO de criação de conta (a tela do operador em
  // /sie/cadastros/addpraticante e o AddUserPage). Com `UID` vazio, cada chamada
  // recebe um uid novo do Auth e a `runTransaction` abaixo nunca dispara — ela só
  // protege uid JÁ CONHECIDO. Ver utils/coalescerCadastro.js.
  /**
   * P13 — a criação de cadastro passou para o SERVIDOR.
   *
   * Este método continua sendo o funil de todos os caminhos que criavam `users`
   * (DadosPessoaisComponent nos dois pontos, AddUserPage e o AUTH RECOVERY do
   * AuthContext), mas agora ele só chama a callable `criarCadastroUsuario`. A
   * assinatura e o retorno são os mesmos, de propósito: nenhuma tela precisou
   * mudar.
   *
   * O que era feito aqui e virou responsabilidade do servidor:
   *   1. conta no Firebase Auth (era `/api/usr/create` chamado ANTES da
   *      gravação — negada a gravação, sobrava conta órfã por tentativa);
   *   2. o documento `users`, com `metadados` ditado pelo servidor e
   *      `successorId: ""` garantido;
   *   3. o praticante mínimo;
   *   4. o grupo padrão, na MESMA transação (antes era uma segunda chamada, que
   *      podia falhar sozinha e deixar o cadastro sem grupo).
   *
   * A guarda de sobrescrita (transação + `exists()`) que morava aqui desde o
   * incidente de 02/09 continua existindo — do lado de lá. Ver
   * `functions/cadastroUsuario.js` e `docs/INCIDENTE-AUTH-RECOVERY-USERS.md`.
   *
   * O `coalescerCadastro` fica: ele evita a segunda ida à rede no duplo clique.
   * Mas a idempotência de verdade agora é do servidor, por identidade — o
   * coalescedor sempre cobriu só a aba, e dois dispositivos passavam os dois.
   */
  createWithID = async (UID, value, doNotCreatePraticante) =>
    coalescerCadastro(`cadastro:${value?.dadosContato?.email || ""}`, async () => {
      const { uid } = await criarCadastroUsuario({
        users: value,
        uid: UID || undefined,
        criarPraticante: doNotCreatePraticante !== true,
      });

      // Replicação para o Firebase Secondary: não bloqueia e não é crítica.
      this.replicateUserToSecondary(uid, value.dadosContato.email, value.dadosPessoais.name, {
        admin: value.isAdmin || false,
        roles: value.roles || [],
      }).catch((error) => {
        console.warn("⚠️ Erro ao replicar usuário para secondary (não crítico):", error.message);
      });

      const returnValue = await this.getOne(uid);
      returnValue.id = uid;
      return returnValue;
    });

  createPraticante = async (UID, value) => {
    try {
      // 🛡️ SEGURANÇA: Verificar se o praticante já existe antes de sobrescrever.
      // setDoc() sem merge DESTRÓI todos os campos existentes.
      // Incidente documentado: praticante teve 32 campos destruídos por sobrescrita parcial.
      const existingDoc = await getDoc(doc(db, "praticantes", UID.toString()));
      if (existingDoc.exists()) {
        console.warn(
          `⚠️ [createPraticante] BLOQUEADO: praticante ${UID} já existe com ` +
          `${Object.keys(existingDoc.data()).length} campos. ` +
          `Sobrescrita com setDoc() sem merge cancelada para evitar perda de dados.`
        );
        return true; // Retorna sem sobrescrever — praticante já existe
      }

      let newPraticante = PraticanteModelo();
      newPraticante = {
        ...newPraticante,
        dadosPessoais: {
          ...newPraticante.dadosPessoais,
          name: value.dadosPessoais.name,
          trigam: value.dadosPessoais.trigam,
          searchableName: normalizarSearchableName(value.dadosPessoais.name),
        },
        dadosContato: {
          ...newPraticante.dadosContato,
          email: value.dadosContato.email,
        },
        metadados: {
          ...newPraticante.metadados,
          ownerid: value.metadados.ownerid,
          owner: value.metadados.owner,
        },
      };
      // //console.log("createPraticante praticantes => UID = ", UID, "newPraticante = ", newPraticante);
      await setDoc(doc(db, "praticantes", UID.toString()), newPraticante);
      return true;
    } catch (error) {
      throw error;
    }
  };

  checkIfEmailExists = async (email) => {
    try {
      let returnValue = null;
      // //console.log("chkemail => email = ", email);
      return await this.makeHybridApiRequest("/api/usr/chkemail", { email: email })
        .then((response) => {
          // //console.log(response);
          returnValue = response.data.value;
          return returnValue;
        }, (error) => {
          throw error;
          // ConsoleLog.log(error);
        });
    } catch (error) {
      throw error;
    }
  };


  checkIfEmailExistsAndID = async (id, email) => {
    try {
      let returnValue = null;
      let urlService = import.meta.env.VITE_BACKEND_API_URL + "/api/usr/chkemail";
      // //console.log("urlService:", urlService);
      // //console.log("chkemail => email = ", email);
      // this.getOne(id).then((retData) => {
      //   console.log("retData = ", retData);
      //   if(retData === undefined) {
      //     console.log("Usuário não encontrado!");
      //   }

      // }).catch((error) => {
      //   throw error;
      // });
      return await this.makeHybridApiRequest("/api/usr/chkemail", { email: email })
        .then((response) => {
          if (response.data.value === true && response.data.uid === id)
            returnValue = [1, ""]; // Email exists and belongs to the same user
          else if (response.data.value === true && response.data.uid !== id)
            returnValue = [-1, response.data.uid]; // Email exists and belongs to another user
          else
            returnValue = [0, ""]; // Email does not exist
          return returnValue;
        }, (error) => {
          throw error;
          // ConsoleLog.log(error);
        });
    } catch (error) {
      throw error;
    }
  };

  createAuthenticationUser = async (UID, email, displayname) => {
    try {
      let returnValue = null;
      // 🔐 Rota de criação de conta no Firebase Auth. Passou a exigir Bearer.
      return await AuthenticatedApiService.post("/api/usr/create", { uid: UID, email: email, displayname: displayname })
        .then((response) => {
          console.log(response);
          returnValue = response;
          return returnValue;
        }, (error) => {
          console.log(error);
          throw error;
          // ConsoleLog.log(error);
        });
      // return returnValue;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  // 🆕 Replicar usuário para Firebase Secondary
  replicateUserToSecondary = async (uid, email, displayname, customClaims) => {
    try {
      console.log("🔄 Iniciando replicação para Firebase Secondary:", uid);
      const response = await AuthenticatedApiService.post("/api/usr/replicate-to-secondary", {
        uid: uid,
        email: email,
        displayname: displayname,
        customClaims: customClaims || {}
      });
      
      console.log("✅ Replicação concluída:", response.data);
      return response.data;
      
    } catch (error) {
      console.error("❌ Erro ao replicar usuário para secondary:", error);
      throw error;
    }
  };

  /**
   * ⚠️ `setDoc` SEM merge: substitui o documento inteiro. Campo que não vier em
   * `value` é APAGADO. Por isso este método relê o documento e devolve à força o
   * que nenhuma tela tem o direito de reescrever.
   *
   * ── 1. O espelho de permissões ────────────────────────────────────────────
   * As Security Rules de `portais`, `servicoshabilitados`, `credenciais_tecnicas`,
   * `auditoriaSeguranca` e `auditoriaIntegridade` leem `users/{uid}.rulesowned`.
   * Qualquer tela que salvasse o usuário (sem esses campos no formulário)
   * derrubava o acesso da pessoa em silêncio — e agora derrubaria o save inteiro,
   * porque a regra de `users` passou a NEGAR escrita que mexa no espelho. O
   * espelho é escrito só pelo Admin SDK (scripts/espelhar-rulesowned.js).
   *
   * ── 2. `metadados.creation` ───────────────────────────────────────────────
   * A data de criação é imutável por definição, e estava sendo DESTRUÍDA a cada
   * save. `AddUserPage` e `VerifyEmailPage` formatam a Timestamp para exibir
   * ("dd/MM/yyyy 'às' HH:mm:ss") e devolvem a string no payload; `new Date()`
   * não lê esse formato, então a guarda `isNaN` daqui trocava a criação por
   * AGORA. Medido em 03/09/2026: 15.854 dos 16.415 documentos já editados
   * (96,6%) estão com `creation == date`, e outros 7.859 guardam uma STRING onde
   * deveria haver Timestamp.
   *
   * Reler e recolocar resolve na origem, sem depender de as telas pararem de
   * formatar. `isNaN` continua valendo só para documento sem `creation`.
   *
   * Não é transacional: entre o `getDoc` e o `setDoc` cabe uma escrita do script
   * do espelho. A janela é de milissegundos e a perda seria de um resync — o
   * script é idempotente e roda de novo.
   */
  update = async (id, value) => {
    try {
      value = { ...value, dadosPessoais: { ...value.dadosPessoais, trigam: generateTrigam(value.dadosPessoais.name) } };
      if (value.metadados.owner === null) value.metadados.owner = value.dadosPessoais.name;

      const ref = doc(db, "users", id.toString());
      const atual = await getDoc(ref);
      const preservados = {};
      let creationOriginal;

      if (atual.exists()) {
        const dados = atual.data();
        if (dados.rulesowned !== undefined) preservados.rulesowned = dados.rulesowned;
        if (dados.rulesownedEspelho !== undefined) preservados.rulesownedEspelho = dados.rulesownedEspelho;
        // Só aceita como criação o que já é Timestamp: os 7.859 documentos com
        // string gravada seriam apenas repropagados.
        if (dados.metadados?.creation?.toDate) creationOriginal = dados.metadados.creation;
      }

      const creation = creationOriginal
        ?? (isNaN(value.metadados.creation) ? Timestamp.fromDate(new Date()) : value.metadados.creation);

      // `version` também precisa de rede: `undefined + 1` é NaN, e NaN gravado em
      // Firestore já rendeu um script de reparo (scripts/fix-nan-versions.js).
      const versionRecebida = Number(value.metadados.version);
      const version = Number.isFinite(versionRecebida) ? versionRecebida : 1;

      return setDoc(ref, {
        ...value,
        metadados: { ...value.metadados, creation, version },
        ...preservados,
      });
    } catch (error) {
      throw error;
    }
  };

  /**
   * Ativa/inativa o cadastro de usuário.
   *
   * ⚠️ O campo é `metadados.active`, NÃO `metadataactive`. Até 04/09/2026 este
   * método gravava o segundo — um campo de topo que NENHUMA consulta lê: das
   * 42.215 pessoas em `users`, 42.215 têm `metadados.active` e ZERO têm
   * `metadataactive`. Ou seja, ele nunca inativou ninguém, e sem erro nenhum.
   *
   * Também havia um `ActualVersion` montado com o valor certo e descartado sem
   * uso — a intenção estava no código, só não chegava ao banco.
   *
   * Escrita por field path: só `metadados.active` entra, o resto do map fica
   * intacto.
   */
  updateActiveState = async (id, newStateValue) => {
    try {
      return await updateDoc(doc(db, "users", id), {
        "metadados.active": newStateValue,
      });
    } catch (error) {
      throw error;
    }
  };

  updatePhoneNumber = async (id, newCelular) => {
    try {
      const response = await AuthenticatedApiService.post("/api/usr/changephonenumber", { uid: id, celular: newCelular });
      return response.data.value === true || response.data.skipped === true;
    } catch (error) {
      console.error("[UsersService] updatePhoneNumber error:", error);
      // Não propagar — falha no Auth não deve bloquear Firestore já salvo
      return false;
    }
  };

  changePassword = async (uid, newPassword) => {
    try {
      // 🔐 HOTFIX 09/09/2026: esta rota trocava a senha de QUALQUER conta a partir
      // do uid, sem autenticação (o uid é o docId de `users`, legível por qualquer
      // autenticado). O servidor passou a exigir Bearer + `decoded.uid === uid`.
      const response = await AuthenticatedApiService.post("/api/usr/changepassword", { uid, newPassword });
      if (response.data.value !== true) return false;
      // Senha trocada, mas a marca de troca obrigatória (D32) ficou no token: o
      // /api/claims/sincronizar tira a claim que sobrou (o users já não exige).
      if (response.data.contaLiberada === false) {
        await AuthenticatedApiService.post("/api/claims/sincronizar", {}).catch((e) =>
          console.warn("[UsersService] troca obrigatória não liberada:", e?.message),
        );
      }
      return true;
    } catch (error) {
      console.error("[UsersService] changePassword error:", error);
      throw error;
    }
  };

  getSessionToken = async () => {
    try {
      return await AuthenticatedApiService.post("/api/usr/session-token", {});
    } catch (error) {
      console.error("[UsersService] getSessionToken error:", error);
      return null;
    }
  };

  /**
   * Valida celular + CPF antes de enviar OTP por SMS.
   * Retorna { valid: true, tokenId } se o par encontrado no Firestore,
   * ou { valid: false } caso contrário (sem revelar qual campo está errado).
   */
  verifySmsIdentity = async (phone, cpf) => {
    try {
      const urlService = import.meta.env.VITE_BACKEND_API_URL + "/api/usr/verify-sms-identity";
      const response = await axios.post(urlService, { phone, cpf });
      return response.data;
    } catch (error) {
      console.error("[UsersService] verifySmsIdentity error:", error);
      throw error;
    }
  };

  /**
   * Redefine a senha do usuário via fluxo SMS.
   * Requer idToken obtido do auth.currentUser após confirmação do OTP.
   * O backend valida o token de pré-verificação e usa Admin SDK para
   * alterar a senha do usuário real (email/senha), não do phone-auth user.
   */
  smsSetPassword = async (tokenId, newPassword, idToken) => {
    try {
      const urlService = import.meta.env.VITE_BACKEND_API_URL + "/api/usr/sms-set-password";
      const response = await axios.post(
        urlService,
        { tokenId, newPassword },
        { headers: { Authorization: `Bearer ${idToken}` } }
      );
      return response.data;
    } catch (error) {
      console.error("[UsersService] smsSetPassword error:", error);
      throw error;
    }
  };

  updateEmail = async (id, newEmail) => {
    try {
      return await AuthenticatedApiService.post("/api/usr/changeemail", { uid: id, email: newEmail })
        .then(async (response) => {
          if (response.data.value) {
            return await updateDoc(doc(db, "users", id), { "dadosContato.email": newEmail })
              .then(async () => {
                return await updateDoc(doc(db, "praticantes", id), { "dadosContato.email": newEmail })
                  .then(async () => {
                    return true;
                  }, (error) => {
                    throw error;
                  });
              }, (error) => {
                throw error;
              });
          }
          else {
            throw new Error("Erro ao alterar email no Firebase Authentication!");
          }
        }, (error) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }

    // //console.log("updateLogin => id = ", id, " newEmail = ", newEmail);
    // try {
    //   return await updateDoc(doc(db, "users", id), { "dadosContato.email": newEmail })
    //   .then(async () => {
    //     return await updateDoc(doc(db, "praticantes", id), { "dadosContato.email": newEmail })
    //     .then(async () => {
    //       let urlService = import.meta.env.VITE_BACKEND_API_URL + "/api/usr/changeemail";
    //       return await axios.post(urlService, {uid: id, email: newEmail})
    //       .then((response) => {
    //         return response.data.value;
    //         // return true;
    //       }, (error) => {
    //         throw error;
    //       });      
    //     });
    //   });
    // } catch (error) {
    //   throw error;
    // }
  };

  updateName = async (id, newName) => {
    // //console.log("updateLogin => id = ", id, " newName = ", newName);
    try {
      return await AuthenticatedApiService.post("/api/usr/changedisplayname", { uid: id, displayname: newName })
        .then(async (response) => {
          if (response.data.value) {
            return await updateDoc(doc(db, "users", id), {
              "dadosPessoais.name": newName,
              "dadosPessoais.searchableName": normalizarSearchableName(newName),
              "dadosPessoais.trigam": generateTrigam(newName),
            }).then(async () => {
              return await updateDoc(doc(db, "praticantes", id), {
                "dadosPessoais.name": newName,
                "dadosPessoais.searchableName": normalizarSearchableName(newName),
                "dadosPessoais.trigam": generateTrigam(newName),
              }).then(async () => {
                return true;
              }, (error) => {
                throw error;
              });
            }, (error) => {
              throw error;
            });
          }
        }, (error) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  };

  addRulesOwnedUnderPortalID = async (id, portalID, newRule) => {
    try {
      // ⚠️ DESATIVADO em 04/09/2026. Este método gravava `usersgroupsowned`
      // direto, e a regra de `users` passou a exigir 100/102 para isso — que
      // ninguém que usa este caminho tem.
      //
      // A concessão de grupos por vínculo (cargo/área de atuação) migrou para a
      // Cloud Function `gruposDeVinculo`, que lê os grupos do DOCUMENTO DE ORIGEM
      // em vez de aceitá-los do cliente. Chame `gruposDeVinculo` de
      // services/GrupoPadrao.service.js.
      //
      // Nota: além do campo, este método também escrevia o documento INTEIRO de
      // volta com `updateDoc`, e só acrescentava no portal que já existisse — se
      // o portal não estivesse na lista, não fazia nada e não avisava.
      throw new Error(
        "addRulesOwnedUnderPortalID foi descontinuado. Use gruposDeVinculo (Cloud Function)."
      );
    } catch (error) {
      throw error;
    }
  };

  // ⚠️ DESATIVADO em 04/09/2026, pelo mesmo motivo de
  // `addRulesOwnedUnderPortalID`: a regra de `users` não aceita mais escrita de
  // `usersgroupsowned` pelo cliente. Use `gruposDeVinculo` com `remover: true`.
  removeRulesOwnedUnderPortalID = async () => {
    try {
      throw new Error(
        "removeRulesOwnedUnderPortalID foi descontinuado. Use gruposDeVinculo({ remover: true })."
      );
    } catch (error) {
      throw error;
    }
  };

  /**
   * Exclusão LÓGICA do usuário: `metadados.active = false`. Nada é apagado.
   *
   * ⚠️ Duas correções em 04/09/2026, ambas de defeitos que nunca chegaram a
   * produzir dado — ver o final desta nota:
   *
   * 1. Gravava `metadataactive` (topo) em vez de `metadados.active`. Campo que
   *    ninguém lê; o cadastro seguia ativo em todas as listagens.
   *
   * 2. Escrevia o documento de USERS dentro de `praticantes/{id}`. O
   *    `ActualVersion` era o `users` inteiro — inclusive `usersgroupsowned` —
   *    mesclado no praticante, sem `await` e sem `catch`, então uma falha
   *    passaria em silêncio.
   *
   *    Esse trecho não foi consertado, foi REMOVIDO: em `praticantes`,
   *    `metadados.active` significa "anuidade da CBTKD paga"
   *    (`AuthContext.cbtkdactive`, `resolverExigenciasAnuidade.exigirCBTKD`).
   *    Inativar um usuário marcaria a anuidade dele como em aberto. Desativar o
   *    cadastro de acesso e mexer na situação financeira do praticante são
   *    coisas diferentes, e este método faz só a primeira.
   *
   * Por que nada disso apareceu na base: o botão que chega aqui
   * (`AddUserPage.deleteEnabled`) exige a regra 203, que NÃO EXISTE no catálogo
   * `securityrules` e não é concedida por nenhum grupo. Ele está invisível para
   * todo mundo, e por isso o método nunca rodou. Medido: 0 documentos de `users`
   * com `metadataactive` e 0 de `praticantes` com `usersgroupsowned`. A correção
   * é preventiva — se a 203 for criada um dia, o caminho já está certo.
   */
  delete = async (id) => {
    try {
      return await updateDoc(doc(db, "users", id), {
        "metadados.active": false,
      });
    } catch (error) {
      throw error;
    }
  };


  redefinePassword = async (UID, email, password) => {
    try {
      let returnValue = null;
      // 🔐 Redefinição de senha por operador (AddUserPage, permissão 202). Exige Bearer.
      return await AuthenticatedApiService.post("/api/usr/rstuser", { uid: UID, email: email, password: password })
        .then((response) => {
          console.log(response);
          returnValue = response;
          return returnValue;
        }, (error) => {
          console.log(error);
          throw error;
          // ConsoleLog.log(error);
        });
      // return returnValue;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  /**
   * Redefine a senha do usuário e envia a nova senha por e-mail.
   * A senha é gerada NO SERVIDOR — nunca trafega ou é exibida no cliente.
   * Requer permissão 3126 do solicitante.
   * @param {string} uid - UID do usuário no Firebase Auth
   * @param {string} email - e-mail cadastrado (precisa bater com o do Auth)
   * @param {string} [nome] - nome para personalizar o e-mail (opcional)
   * @returns {Promise<{ value: boolean }>}
   */
  redefinePasswordSendEmail = async (uid, email, nome = "") => {
    try {
      const response = await AuthenticatedApiService.post("/api/usr/rstuser-email", {
        uid,
        email,
        nome,
      });
      return response.data;
    } catch (error) {
      console.error("[UsersService] redefinePasswordSendEmail error:", error);
      throw error;
    }
  };

  /**
   * Verifica integridade do cadastro do praticante (silencioso/auditoria).
   * @param {string} praticanteId
   * @returns {Promise<{ ok: boolean, problemas: any[], gruposFaltantes: any[] }>}
   */
  verificarIntegridadePraticante = async (praticanteId) => {
    try {
      const response = await AuthenticatedApiService.post(
        "/api/praticantes-integridade/verificar",
        { praticanteId }
      );
      return response.data;
    } catch (error) {
      // Não lançamos: a verificação é silenciosa para o usuário comum.
      console.warn("[UsersService] verificarIntegridadePraticante falhou:", error?.message);
      return { ok: false, problemas: [{ tipo: "ERRO_REQUISICAO" }], gruposFaltantes: [] };
    }
  };


}

export default new usersService();
